import DOMPurify from 'dompurify';

const CONFIG = {
  ALLOWED_TAGS: [
    'p', 'br', 'strong', 'b', 'em', 'i', 'u', 's',
    'ul', 'ol', 'li',
    'h2', 'h3', 'h4',
    'blockquote', 'a', 'span', 'div',
  ],
  ALLOWED_ATTR: ['href', 'title', 'target', 'rel', 'class'],
  ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|tel:|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
};

DOMPurify.addHook?.('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

/**
 * The server already sanitizes rich text on write. This is the second layer, so
 * anything stored before that guard existed still renders inert.
 */
export const sanitizeHtml = (value) => (typeof value === 'string' ? DOMPurify.sanitize(value, CONFIG) : '');

export const richText = (value) => ({ __html: sanitizeHtml(value) });
